import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PerformanceReportsPage = () => {
  return (
    <Container fluid className="px-3">
      <div className="pb-4">
        <div className="mb-4">
          <h2 className="mb-2">Reportes de Performance</h2>
          <h5 className="text-700 fw-semi-bold">
            Reportes detallados de rendimiento y métricas
          </h5>
        </div>
        
        <Card className="text-center py-5">
          <Card.Body>
            <FontAwesomeIcon icon="chart-bar" className="fs-3 text-300 mb-3" />
            <h5 className="text-800">Próximamente</h5>
            <p className="text-600 mb-3">Esta sección estará disponible pronto.</p>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default PerformanceReportsPage; 